import { useEffect } from "react";
import { useUserDataFlattened } from "../user/stores";
import { useNotificationStore } from "./stores";

/**
 * 消息通知 Hook
 *
 * 独立出来的原因：`notification/index.ts` 既导出此 Hook 又导出
 * `MailIconWithBadge.tsx`，而 `MailIconWithBadge` 内部又需要使用此 Hook，
 * 从 index 桶里取它会形成 `MailIconWithBadge ↔ notification/index` 自反环。
 * 将 Hook 单独放到这个文件，两个消费者直接从这里引入即可打破闭环。
 *
 * 只监听 noticeUpdateTime 变化，变化时自动调用 store 中的
 * setUserNoticeUpdateTime，所有业务逻辑仍由 store 处理。
 */
export function useMessageNotification() {
  const { noticeUpdateTime } = useUserDataFlattened();
  const {
    messageUnreadCount,
    setUserNoticeUpdateTime,
    loadMessageUnreadCount,
  } = useNotificationStore();

  useEffect(() => {
    if (noticeUpdateTime !== undefined) {
      setUserNoticeUpdateTime(noticeUpdateTime);
    }
  }, [noticeUpdateTime, setUserNoticeUpdateTime]);

  return {
    messageUnreadCount,
    refresh: loadMessageUnreadCount,
  };
}
